import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'medpace-request-error-modal',
    standalone: false,
    templateUrl: './request-error-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./request-error-modal.component.scss'],
})
export class MedpaceRequestErrorModalComponent {
    constructor(public dialogRef: MatDialogRef<MedpaceRequestErrorModalComponent>) {}

    closeDialog(): void {
        this.dialogRef.close();
    }
}
